(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function segment(number, label) {
    return (
      '<span class="product-countdown__segment">' +
      '<span class="product-countdown__number">' + number + '</span>' +
      '<span class="product-countdown__label">' + label + '</span>' +
      '</span>'
    );
  }

  function separator() {
    return '<span class="product-countdown__separator"> : </span>';
  }

  function formatCountdownHtml(ms) {
    var totalSec = Math.max(0, Math.floor(ms / 1000));
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;
    var parts = [];

    if (days > 0) {
      parts.push(segment(days, 'd'));
    }

    parts.push(segment(pad(hours), 'h'));
    parts.push(segment(pad(minutes), 'm'));
    parts.push(segment(pad(seconds), 's'));

    return parts.join(separator());
  }

  function tick() {
    document.querySelectorAll('.product-countdown[data-countdown-end]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-countdown-end'), 10) * 1000;
      var timer = el.querySelector('[data-countdown-timer]');

      if (!timer || isNaN(end)) {
        return;
      }

      var diff = end - Date.now();

      if (diff <= 0) {
        el.remove();
        return;
      }

      timer.innerHTML = formatCountdownHtml(diff);
    });
  }

  function init() {
    tick();
  }

  window.theme = window.theme || {};
  window.theme.productCountdownTick = tick;

  if (!window.__productCountdownInterval) {
    window.__productCountdownInterval = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
